import React from 'react';
import { useGetOnboardingFunnelQuery } from 'store/services/admin/analyticsApi';
import { AnalyticsPeriod } from 'types/interfaces/admin/analytics';
import FunnelChart from 'components/admin/charts/FunnelChart';

interface Props {
  period: AnalyticsPeriod;
  onPeriodChange: (period: AnalyticsPeriod) => void;
}

const OnboardingFunnelChart: React.FC<Props> = ({ period, onPeriodChange }) => {
  const { data, isLoading, error, refetch } = useGetOnboardingFunnelQuery({ period });

  return (
    <FunnelChart
      title="Onboarding Funnel"
      subtitle="User progression through onboarding steps. Each bar shows users who completed that step. (UTC)"
      steps={data?.steps || []}
      totalCohortSize={data?.totalCohortSize || 0}
      period={period}
      onPeriodChange={onPeriodChange}
      isLoading={isLoading}
      error={!!error}
      onRetry={refetch}
    />
  );
};

export default OnboardingFunnelChart;
